import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmationStep from '../shared/ConfirmationStep';
import { StyMultiStepModal } from '../shared/StyMultiStepModal';
import { useDeleteInitialisation } from './hook';

type Props = {
    isModalShown: boolean;
    setShowModal: DispatchState<boolean>;
    initialisationId: number;
};

export default function DeleteInitialisationModal({
    isModalShown,
    setShowModal,
    initialisationId,
}: Props): React.ReactElement {
    const { t } = useTranslation();
    const [confirmationIsValid, setConfirmationIsValid] =
        useState<boolean>(false);

    const { mutate: deleteInitialisation } =
        useDeleteInitialisation(initialisationId);

    const onConfirmAction = () => {
        deleteInitialisation();
    };

    const steps = [
        {
            confirmAction: {
                enabled: confirmationIsValid,
                onClick: onConfirmAction,
                label: 'common.confirm',
            },
            stepBackAction: {
                onClick: () => {
                    setShowModal(false);
                },
                enabled: true,
            },
            disableClose: true,
            node: (
                <ConfirmationStep
                    title={t('adminBudgetSpace.deleteInitialisation.title')}
                    text={t('adminBudgetSpace.deleteInitialisation.text')}
                    confirmationIsValid={confirmationIsValid}
                    setConfirmationIsValid={setConfirmationIsValid}
                />
            ),
        },
    ];
    return (
        <StyMultiStepModal
            isOpen={isModalShown}
            onClose={() => {
                setShowModal(false);
            }}
            maxWidth="md"
            steps={steps}
            showCloseIcon={true}
        />
    );
}
